var arrMin = require('../array/min');
var values = require('./values');

    /**
     * Returns minimum value inside object.
     */
    function min(obj, iterator) {
        return arrMin(values(obj), iterator);
    }

    module.exports = min;




//////////////////
// WEBPACK FOOTER
// ./~/mout/object/min.js
// module id = 715
// module chunks = 0 1 2